import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBulb = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.8,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M15 14c.2-1 .72-1.66 1.5-2.5A5.9 5.9 0 0 0 18 7.5 6 6 0 0 0 6 7.5c0 1 .23 2.23 1.5 4 .78.84 1.3 1.5 1.5 2.5" }),
		/* @__PURE__ */ _jsx("line", {
			x1: 9,
			y1: 18,
			x2: 15,
			y2: 18
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 10,
			y1: 21.5,
			x2: 14,
			y2: 21.5
		})
	]
});
export default SvgBulb;
